import { render, staticRenderFns } from "./MonetaryCompensationUpdate.vue?vue&type=template&id=c142c0ee"
import script from "./MonetaryCompensationUpdate.vue?vue&type=script&lang=js"
export * from "./MonetaryCompensationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports